export interface AuthState {
  user: {
    permissions: string[];
    hasAllAccess: boolean;
    [key: string]: any;
  } | null;
  token: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
};

type AuthAction =
  | {
      type: "LOGIN_SUCCESS";
      payload: { user: any; token: string | null };
    }
  | { type: "LOGOUT" };

const authReducer = (
  state: AuthState = initialState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case "LOGIN_SUCCESS": {
      const { user, token } = action.payload || {};
      return {
        ...state,
        user: user
          ? {
              ...user,
              permissions: Array.isArray(user.permissions)
                ? user.permissions
                : [],
              hasAllAccess: Boolean(user.hasAllAccess),
            }
          : null,
        token: token || null,
      };
    }
    case "LOGOUT":
      return { ...state, user: null, token: null };
    default:
      return state;
  }
};

export default authReducer;
